import { Controller } from "@hotwired/stimulus";
import { clearInputs, show, hide } from '../utils/stimulus_form_helper';

// Connects to data-controller="au-address-fields"
export default class extends Controller {
  static targets = ['cityInput', 'citySelector', 'stateSelector', 'postcodeInput', 'citySelectorWrapper', 'cityInputWrapper'];

  connect() {
    // default state - select input hidden, text input shown
    hide(this.citySelectorWrapperTarget);
  }

  showCitySelector(codes) {
    // Clear existing options
    this.citySelectorTarget.innerHTML = '';

    // Add a default option
    const defaultOption = document.createElement('option');
    defaultOption.value = '';
    defaultOption.textContent = 'Please select a suburb';
    this.citySelectorTarget.appendChild(defaultOption);

    // Add options dynamically
    codes.forEach(code => {
      const option = document.createElement('option');
      option.value = code.locality;
      option.textContent = code.locality;
      option.dataset.state = code.state;
      this.citySelectorTarget.appendChild(option);
    });

    show(this.citySelectorWrapperTarget);

    if (this.cityInputTarget.value) {
      // If the city input had a value, then try to apply it
      this.citySelectorTarget.value = this.cityInputTarget.value;

      // But if the value didn't get accepted, then just clear it
      if (!this.citySelectorTarget.value) {
        clearInputs(this.citySelectorTarget);
      }
    }

    this.citySelectorTarget.dispatchEvent(new Event('change'));
    hide(this.cityInputWrapperTarget);
  }

  showCityInput() {
    hide(this.citySelectorWrapperTarget);
    show(this.cityInputWrapperTarget);
  }

  applyCitySelectChange() {
    const selectedState = this.citySelectorTarget.options[this.citySelectorTarget.selectedIndex]?.dataset.state;

    this.cityInputTarget.value = this.citySelectorTarget.value;
    if (selectedState) this.stateSelectorTarget.value = selectedState.toLowerCase();
  }

  applyPostcodeChange(event) {
    const postcode = event.target.value;

    if (postcode.length === 4) {
      fetch(`/quote/postcode_search?code=${postcode}`)
        .then(response => response.json())
        .then(codes => {
          if (codes.length > 0) {
            this.showCitySelector(codes);
          } else {
            this.showCityInput();
          }
        })
        .catch(error => console.error('Error fetching postcode data:', error));
    } else {
      this.showCityInput();
    }
  }
}
